// src/LandingPage.js
import React, { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Technology from './components/Technology';
import Portfolio from './components/Portfolio';
import Experience from './components/Experience';
import BlogSection from './components/BlogSection';
import Reviews from './components/Reviews';
import Footer from './components/Footer';
import SEO from './components/SEO';

const LandingPage = () => {
  useEffect(() => {
    document.body.classList.add('landing-active');
    return () => {
      document.body.classList.remove('landing-active');
    };
  }, []);
  return (
    <div className="bg-[#0d0d0d] min-h-screen landing-page">
      <SEO />
      {/* Hero covers the full width */}
      <Hero />
      <Header />

      {/* Wrap the rest of the content in a container with consistent vertical spacing */}
      <div className="w-full md:w-2/3 mx-auto">
        <main className="px-4 space-y-12 md:space-y-16">
          <Technology />
          <Portfolio />
          <Experience />
          <BlogSection />
          <Reviews />
          <Footer />
          {/* Extra bottom padding if needed */}
          <div className="pb-8"></div>
        </main>
      </div>
    </div>
  );
};

export default LandingPage;